export default __webpack_public_path__ + "static/media/spinandwheelreel.99eba21f.mp3";